<template>
  <div id="wrapper">
    <Nav :message="message" />
    <SettingsForm />
  </div>
</template>
<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import SettingsForm from '@/components/SettingsForm.vue'

export default {
  name: 'settings',
  props: ['message'],
  components: {
    Nav,
    SettingsForm
  }
}
</script>